/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { __ } from '@web-stories-wp/i18n';
import { SimplePanel } from '../../panel';
/**
 * Internal dependencies
 */
import { Row as DefaultRow, TextArea } from '../../../form';
import { inputContainerStyleOverride, getCommonValue } from '../../shared';
import { MULTIPLE_DISPLAY_VALUE, MULTIPLE_VALUE } from '../../../../constants';

const Row = styled(DefaultRow)`
  position: relative;
`;

function AutomationKeyPanel({ selectedElements, pushUpdate }) {
  const automationKey = getCommonValue(selectedElements, 'key', '');

  return (
    <SimplePanel name="key" title="Automation Key">
      <Row>
        <TextArea
          aria-label="Automation Key"
          suffix="Automation Key"
          disabled={selectedElements.length > 1}
          readOnly={selectedElements.length > 1}
          value={automationKey || ''}
          containerStyleOverride={inputContainerStyleOverride}
          isIndeterminate={MULTIPLE_VALUE === automationKey}
          placeholder={
            MULTIPLE_VALUE === automationKey
              ? MULTIPLE_DISPLAY_VALUE
              : 'Automation Key'
          }
          onBlur={(evt) => {
            pushUpdate({ key: evt.target.value || null }, true);
          }}
          onChange={(evt) => {
            pushUpdate({ key: evt.target.value || null }, false);
          }}
        />
      </Row>
    </SimplePanel>
  );
}

AutomationKeyPanel.propTypes = {
  selectedElements: PropTypes.array.isRequired,
  pushUpdateForObject: PropTypes.func.isRequired,
  pushUpdate: PropTypes.func.isRequired,
};

export default AutomationKeyPanel;
